class NavigateTo extends HTMLElement {
  constructor() {
    super();
    this.navigation = this.querySelector(".sticky-main-navigation");
    this.stickyDiv = this.querySelector(".sticky-hight");
    this.button = this.querySelector(".nav-toggle");
    this.menu = this.querySelector(".nav-menu");
    this.nav = this.querySelector("nav");
    this.isOpen = false;
    this.init();
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', this.toggleMenu.bind(this));
      this.enableSticky();

      // Handle outside click and Escape
      document.addEventListener("click", this.handleDocumentClick.bind(this));
      document.addEventListener("keydown", this.handleKeyDown.bind(this));
    }
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
    this.button.classList.toggle("active", this.isOpen);
    this.menu.classList.toggle("active", this.isOpen);
  }

  closeMenu() {
    if (this.isOpen) {
      this.isOpen = false;
      this.button.classList.remove("active");
      this.menu.classList.remove("active");
    }
  }

  handleDocumentClick(event) {
    if (this.isOpen && !this.nav.contains(event.target)) {
      this.closeMenu();
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.closeMenu();
    }
  }

  enableSticky() {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
  
    const options = {
      root: null,
      threshold: 1,
      rootMargin: `-${headerHeight + 1}px 0px 0px 0px`
    };
  
    this.observer = new IntersectionObserver((entries) => {
      const elementHeight = this.navigation.getBoundingClientRect().height;
      const entry = entries[0];
      if (entry.boundingClientRect.top < headerHeight) {
        this.navigation.classList.add('is-pinned');
        this.stickyDiv.style.height = elementHeight+'px';
        this.stickyDiv.style.display = 'block';
      } else {
        this.navigation.classList.remove('is-pinned');
        this.stickyDiv.style.height = 0;
        this.stickyDiv.style.display = 'none';
      }
    }, options);
  
    this.observer.observe(this);
  }
}

customElements.define('navigate-to', NavigateTo);
